import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobBenefitsEn = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id}>
      <FormEditorQuill field='benefits_en' disabled={disabled} />
    </BWAccordion>
  );
};

export default JobBenefitsEn;
